"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dependency_1 = require("./dependency");
const fetch_1 = require("./fetch");
function createEmptyModule(meta) {
    return Object.assign(Object.assign({}, meta), { setup() { } });
}
function loadFromContent(meta, content, getDependencies, link) {
    const dependencies = Object.assign({}, (getDependencies(meta) || {}));
    const app = dependency_1.compileDependency(meta.name, content, link, dependencies);
    return Object.assign(Object.assign({}, app), meta);
}
/**
 * Loads the given raw module content by resolving its dependencies and
 * evaluating the content.
 * @param meta The raw module content as received from the server.
 * @param fetchDependency The function to resolve a dependency.
 * @param dependencies The already evaluated global dependencies.
 * @returns A promise leading to the module content which has the metadata and a `setup` function.
 */
function loadModule(meta, getDependencies, fetchDependency = fetch_1.defaultFetchDependency) {
    const { link, content } = meta;
    const retrieve = link ? fetchDependency(link) : content ? Promise.resolve(content) : undefined;
    if (retrieve) {
        return retrieve.then(content => loadFromContent(meta, content, getDependencies, link));
    }
    else {
        console.warn('Empty module found!', meta.name);
    }
    return Promise.resolve(createEmptyModule(meta));
}
exports.loadModule = loadModule;
